import { getOperationName } from '@apollo/client/utilities';
import * as yup from 'yup';

import type { InvestorEmployeeCreateDtoInput } from '../../../../../../../../../graphql';
import { RolodexRecordStatus } from '../../../../../../../../../graphql';
import { CrmManagement_InvestorFirms_InvestorFirmDetailDocument } from '../../../../graphql/__generated__';
import type { UpdateInvestorFirmEmployee } from '../../../EditInvestorContactDialog/EditInvestorContactDialog.model';

export const refetchQueriesAfterContactCreation = [
  getOperationName(CrmManagement_InvestorFirms_InvestorFirmDetailDocument)!,
];

export const INITIAL_VALUES: InvestorEmployeeCreateDtoInput = {
  employeeKey: '',
  name: '',
  status: RolodexRecordStatus.Effective,
  email1: '',
  email2: null,
  phoneNumber1: null,
  phoneNumber2: null,
  titles: [],
  address1: null,
  address2: null,
  faxNumber1: null,
  faxNumber2: null,
};

export const editInvestorContactValidationSchema: yup.ObjectSchema<UpdateInvestorFirmEmployee> =
  yup.object({
    employeeKey: yup.string().nullable().defined(),
    name: yup.string().label('Contact Name').required(),
    email1: yup.string().label('Email Address (Primary)').required(),
    address1: yup.string().nullable(),
    address2: yup.string().nullable(),
    phoneNumber1: yup.string().nullable(),
    phoneNumber2: yup.string().nullable(),
    email2: yup.string().nullable(),
    titles: yup.array().nullable(),
    status: yup
      .mixed<RolodexRecordStatus>()
      .oneOf(Object.values(RolodexRecordStatus))
      .label('Status')
      .required(),
    faxNumber1: yup.string().nullable(),
    faxNumber2: yup.string().nullable(),
  });

export const newInvestorContactValidationSchema: yup.ObjectSchema<InvestorEmployeeCreateDtoInput> =
  editInvestorContactValidationSchema.concat(
    yup.object({
      employeeKey: yup.string().label('Employee Key').required(),
    })
  );
